import React from "react";
import MainInput from "components/MainApp/atoms/Forms/MainInput";

import styles from "./ContactForm.module.scss";
import i18n from "i18n";

export class ContactForm extends React.Component {
  render() {
    const { provider, handleChange, error } = this.props;

    return (
      <>
        <div
          className={styles["provider-contact-field"]}
          data-automation-id="input-address"
        >
          <MainInput
            label={i18n.t("address")}
            required={false}
            id={"provider-address"}
            name="address"
            value={provider ? provider.address : ""}
            handleChange={handleChange}
            maxLength={30}
            error={error.address && error.address}
          />
        </div>
        <div
          className={styles["provider-contact-field"]}
          data-automation-id="input-phone"
        >
          <MainInput
            label={i18n.t("phone")}
            required={true}
            id={"provider-phone"}
            name="phone"
            value={provider ? provider.phone : ""}
            handleChange={handleChange}
            maxLength={30}
            error={error.phone && error.phone}
          />
        </div>
        <div
          className={styles["provider-contact-field"]}
          data-automation-id="input-email"
        >
          <MainInput
            label={"Email"}
            required={false}
            id={"provider-email"}
            name="email"
            value={provider ? provider.email : ""}
            handleChange={handleChange}
            maxLength={30}
            error={error.email && error.email}
          />
        </div>
      </>
    );
  }
}

export default ContactForm;
